import React from "react";
import propsType from "prop-types";
import { Select } from "antd";
const { Option } = Select;
// const menu = () => {
//   const handleMenuClick = (e) => {
//     console.log("Menu", e);
//   };
//   return (
//     <Menu onClick={handleMenuClick}>
//       <Menu.Item>
//         <Checkbox value="thai_post">Thai Post</Checkbox>
//       </Menu.Item>
//       <Menu.Item>
//         <Checkbox value="thai_post">AIA</Checkbox>
//       </Menu.Item>
//     </Menu>
//   );
// };
// const DropDownMonitor = (props) => {
//   const { options, values, onChange } = props;
//    const [value, setValue] = useState([1, 2, 3, 4, 5, 6, 7]);
//   const selectProps = {
//     mode: "multiple",
//     style: {
//       width: "100%",
//     },
//     value: values,
//     options: options,
//     allowClear: true,
//     showArrow: true,
//     onChange: (newValue) => {
//       onChange(newValue);
//        console.log("newValue", newValue);
//     },
//     placeholder: "Select Item...",
//     maxTagCount: "responsive",
//   };
//   return (
//     <Space
//       direction="vertical"
//       style={{
//         width: "100%",
//       }}
//     >
//       <Select {...selectProps} />
//     </Space>
//     <Dropdown overlay={menu}>
//       <Button
//         onClick={(e) => e.preventDefault()}
//         style={{ color: "#000f9f", fontWeight: "700" }}
//       >
//         <span style={{ paddingRight: "140px" }}>KCS</span>
//         <DownOutlined />
//       </Button>
//     </Dropdown>
//   );
// };
// export default DropDownMonitor;

const OperatorNameDropdown = ({ defaultValue, optionList, onChange }) => {
  return (
    <Select
      mode="multiple"
      placeholder="Select"
      className="w-100"
      value={defaultValue}
      onChange={onChange}
    >
      {optionList?.map((s, i) => (
        <Option key={`multiOption_${i}`} value={s?.value}>
          <span className="default-thai-font">{s?.label}</span>
        </Option>
      ))}
    </Select>
  );
};

OperatorNameDropdown.propsType = {
  defaultValue: propsType.any.isRequired,
  optionList: propsType.array.isRequired,
  onChange: propsType.func.isRequired,
};

export default OperatorNameDropdown;
